import { getRandomArrayElement } from '@sketchnote/shared-components';
import GALLERY from 'src/constants/coverImages.json';

export function getRandomCoverImage() {
  return getRandomArrayElement(
    GALLERY.map((obj) => obj.images)
      .flat()
      .map((obj) => obj.src)
  );
}
